import React from 'react';
import { Link } from 'react-router-dom';
import ProgressBar from '../ProgressBar';

const Card = ({ children, ...props }) => {
  let nome, email, telefone, password;

  const invalidEmail = props.userHasErrored.error === 'auth/invalid-email';
  const weakPassword = props.userHasErrored.error === 'auth/weak-password';

  return (
    <div className="card-login mdl-card mdl-shadow--2dp">
      <div className="m-4">
        <div className="mt-4">

          <div className="form-group">
            <input type="text" className="form-control" placeholder="Nome" ref={ node => nome = node } />
          </div>

          <div className={`form-group ${invalidEmail ? 'has-danger' : ''}`}>
            <input type="email" className="form-control" placeholder="E-mail"  ref={ node => email = node } />
            { invalidEmail && <small className="form-control-feedback">É necessário preencher com um e-mail válido.</small> }
          </div>

          <div className="form-group">
            <input type="phone" className="form-control" placeholder="Telefone" ref={ node => telefone = node } />
          </div>

          <div className={`form-group ${weakPassword ? 'has-danger' : ''}`}>
            <input type="password" className="form-control" placeholder="Senha" ref={ node => password = node } />
            { weakPassword && <small className="form-control-feedback">Sua senha deve ter no mínimo 6 caracteres.</small> }
          </div>

          <button className="sign-in-btn mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect mdl-button--accent"
            onClick={ () => props.mailSignUp(email.value, password.value, nome.value, telefone.value) }>
            { props.userIsLoading ? 'aguarde...' : 'Cadastrar' }
          </button>
          <ProgressBar style={{ display: props.userIsLoading ? 'block' : 'none' }} />
          <div className="mdl-card__supporting-text">
            Já tem conta? <Link to="/login">Entrar</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/login/CardSignUp.js